// src/pages/ContactPage.js
import React, { useEffect, useState } from 'react'
import { Mail, Phone, MapPin, ShieldCheck, MessageSquare, Send } from 'lucide-react'
import profile from '../Images/Profile.png'
import { toast } from 'react-toastify';


import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase1"; // your initialized Firestore

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  })

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  // const handleSubmit = (e) => {
  //   e.preventDefault()
  //   // For demo: alert, replace with email API like EmailJS or backend endpoint
  //   alert(`Thank you ${formData.name}, your message has been sent!`)
  //   setFormData({ name: '', email: '', message: '' })
  // }

    const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "ContactMessages"), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      toast.success("Message sent successfully! 📩");

      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending message: ", error);
      toast.error("Failed to send message ❌");
    }
  };

   useEffect(() => {
    document.title = "Omkar More – Contact | IT & NDT Expert";
    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        "content",
        "Get in touch with Omkar More, an IT and NDT professional specializing in industrial inspection, web development, SaaS, and full-stack solutions."
      );
    }
    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    if (keywordsMeta) {
      keywordsMeta.setAttribute(
        "content",
        "Omkar More, Contact, IT, NDT, Industrial Inspection, Full-Stack Developer, SaaS, Web Development"
      );
    }
  }, []);

  return (
<div className="bg-slate-50 min-h-screen pb-20">
      {/* 1. HERO HEADER - Shared Design Pattern */}
      <section className="bg-white border-b border-slate-200 pt-24 md:pt-32 pb-12 md:pb-16 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row justify-between lg:items-end gap-8">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 md:w-10 h-[1px] bg-cyan-600" />
                <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase font-black text-slate-400">
                  Secure Communication
                </span>
              </div>
              <h1 className="text-4xl sm:text-5xl md:text-7xl font-black text-slate-950 tracking-tighter leading-tight">
                Establish <span className="text-cyan-600 font-light italic">Contact</span>
              </h1>
            </div>
           
          </div>
        </div>
      </section>

      {/* 2. CONTACT GRID */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 mt-12 md:mt-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* Left Column: Profile & Intel (5 Cols) */}
          <div className="lg:col-span-5 space-y-8">
            <div className="relative group">
              {/* Decorative Background Frame */}
              <div className="absolute -inset-4 bg-slate-200/50 rounded-[2.5rem] -z-10 group-hover:bg-cyan-100/50 transition-colors duration-500" />
              
<div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] border border-slate-200 bg-white">
  <img
    src={profile}
    alt="Omkar More Professional Headshot"
    className="object-cover w-full h-full   transition-all duration-700 object-top scale-110"
    style={{ objectPosition: 'center 1%' }} 
  />
  
  {/* The Metadata Card remains fixed at the bottom */}
  <div className="absolute bottom-6 left-6 right-6 p-4 bg-white/90 backdrop-blur-md rounded-2xl border border-white/20 shadow-xl">
    <div className="flex items-center justify-between">
      <div>
        {/* <p className="font-mono text-[10px] font-black text-cyan-600 uppercase">Subject_01</p> */}
        <p className="text-sm font-black text-slate-950 uppercase tracking-tight">Omkar More</p>
      </div>
      <ShieldCheck className="text-cyan-600" size={20} />
    </div>
  </div>
</div>
            </div>

            {/* Quick Contact Links */}
            <div className="grid grid-cols-1 gap-4">
              <a href="mailto:moreomkar972@gmail.com" className="flex items-center gap-4 p-5 bg-white border border-slate-200 rounded-2xl hover:border-cyan-500 group transition-all">
                <div className="p-3 bg-slate-50 rounded-xl group-hover:bg-cyan-50 transition-colors">
                  <Mail className="text-slate-400 group-hover:text-cyan-600" size={20} />
                </div>
                <div>
                  <p className="font-mono text-[9px] font-black text-slate-300 uppercase">Email_Relay</p>
                  <p className="text-sm font-bold text-slate-700">moreomkar972@gmail.com</p>
                </div>
              </a>

              <a href="https://wa.me/919930405472" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-5 bg-white border border-slate-200 rounded-2xl hover:border-cyan-500 group transition-all">
                <div className="p-3 bg-slate-50 rounded-xl group-hover:bg-cyan-50 transition-colors">
                  <MessageSquare className="text-slate-400 group-hover:text-cyan-600" size={20} />
                </div>
                <div>
                  <p className="font-mono text-[9px] font-black text-slate-300 uppercase">Direct_Comms</p>
                  <p className="text-sm font-bold text-slate-700">WhatsApp Dispatch</p>
                </div>
              </a>

              <div className="flex items-center gap-4 p-5 bg-white border border-slate-200 rounded-2xl">
                <div className="p-3 bg-slate-50 rounded-xl">
                  <MapPin className="text-slate-400" size={20} />
                </div>
                <div>
                  <p className="font-mono text-[9px] font-black text-slate-300 uppercase">Location_ID</p>
                  <p className="text-sm font-bold text-slate-700">Mumbai, MH, India</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Communication Form (7 Cols) */}
          <div className="lg:col-span-7 bg-white border border-slate-200 rounded-[2.5rem] p-8 md:p-12 shadow-2xl shadow-slate-200/50">
            <div className="mb-10">
              <h3 className="text-2xl font-black text-slate-950 uppercase tracking-tight mb-2">Message Terminal</h3>
              <p className="text-slate-500 text-sm">Please provide your details to initialize a formal inquiry.</p>
            </div>

            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="font-mono text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Identity_Name</label>
                  <input
                    type="text"
                    placeholder="E.g. John Doe"
                    className="w-full bg-slate-50 border border-slate-100 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-cyan-500/20 focus:bg-white focus:border-cyan-500 transition-all text-sm font-medium"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                </div>
                <div className="space-y-2">
                  <label className="font-mono text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Address_Email</label>
                  <input
                    type="email"
                    placeholder="name@company.com"
                    className="w-full bg-slate-50 border border-slate-100 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-cyan-500/20 focus:bg-white focus:border-cyan-500 transition-all text-sm font-medium"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label className="font-mono text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Payload_Data</label>
                <textarea
                  placeholder="Describe your project or inspection requirements..."
                  className="w-full bg-slate-50 border border-slate-100 rounded-xl px-5 py-4 h-48 resize-none focus:outline-none focus:ring-2 focus:ring-cyan-500/20 focus:bg-white focus:border-cyan-500 transition-all text-sm font-medium"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                />
              </div>

              <button
                type="submit"
                className="group w-full flex items-center justify-between bg-slate-950 text-white font-black text-[10px] md:text-xs uppercase tracking-[0.2em] rounded-2xl px-8 py-5 hover:bg-cyan-600 transition-all active:scale-[0.98] shadow-xl shadow-slate-200"
              >
                Dispatch Message
                <div className="flex items-center gap-2">
                  <span className="w-8 h-px bg-white/20 group-hover:w-12 transition-all" />
                  <Send size={16} />
                </div>
              </button>
            </form>

            <div className="mt-10 pt-8 border-t border-slate-50 flex items-center justify-between">
              <div className="flex gap-1.5">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="w-1.5 h-1.5 rounded-full bg-slate-100" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  )
}
